// packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
// styles
import 'font-awesome/less/font-awesome.less';
import './RelatedTransaction.less';

class PublicLinkPopup extends Component {
  static propTypes = {
    closePopup: PropTypes.func,
    public_pdf_link: PropTypes.string,
    friendly_name: PropTypes.string,
  };

  static defaultProps = {
    closePopup: () => null,
    public_pdf_link: '',
    friendly_name: '',
  };

  render() {
    const publicLinkHtml = `<a href="${this.props.public_pdf_link}">${this.props.friendly_name}</a>`;
    return (
      <div className="menu public-popup">
        <i onClick={this.props.closePopup} className="fa fa-times-circle" style={{ float: 'right', fontSize: '16px' }} />
        <div className="item">
              For Public Download Link:
        </div>
        <div className="item">
          <a href={this.props.public_pdf_link}>
            <span className="pdf icon" /> Right-Click Copy This Link
          </a>
        </div>
        <div className="item">
              Or copy HTML Code below:
        </div>
        <div className="item">
          <textarea rows="7" cols="30" defaultValue={publicLinkHtml} onFocus={e => e.target.select()} />
        </div>

      </div>
    );
  }
}

export default PublicLinkPopup;



// WEBPACK FOOTER //
// ./src/components/case/related_transaction/PublicLinkPopup.jsx